import {
  IAttribute,
  IComponent,
  IConfiguration,
  IOption,
  ISelectedOptions
} from '../Interface/Interface';
import { first } from 'lodash';

export const findOptionByIdentifier = (
  optionIdentifier: string,
  configuration: IConfiguration,
  componentIdentifier: string | undefined
): IOption | undefined => {
  for (const component of configuration?.components || []) {
    if (componentIdentifier && component.identifier !== componentIdentifier) {
      continue;
    }
    for (const option of component.options) {
      if (optionIdentifier === option.identifier) {
        return option;
      }
    }
  }
  return;
};

export const isOptionSelected = (
  option: IOption,
  selectedOptions: IOption[] | undefined
): boolean => {
  let isSelected = false;
  if (selectedOptions && selectedOptions) {
    const selectedOption = selectedOptions.find(
      (selectedOption) => selectedOption.identifier === option.identifier
    );
    if (selectedOption) {
      isSelected = true;
    }
  }
  return isSelected;
};

export const findSelectedOptionAmount = (
  option: IOption | undefined,
  selectedOptions: IOption[] | undefined
): number => {
  let amount = 0;
  if (option && selectedOptions) {
    const selectedOption = selectedOptions.find(
      (selectedOption) => selectedOption.identifier === option.identifier
    );
    if (selectedOption) {
      amount = selectedOption.amount;
    }
  }
  return amount;
};

export const findComponentByIdentifier = (
  componentIdentifier: string,
  configuration: IConfiguration
): IComponent | undefined => {
  for (const component of configuration?.components || []) {
    if (componentIdentifier === component.identifier) {
      return component;
    }
  }
  return;
};

export const getNumberOfSelectedOptions = (
  component: IComponent,
  selectedOptions: ISelectedOptions
): number => {
  let numSelected = 0;
  component.options.forEach((option) => {
    numSelected += findSelectedOptionAmount(option, selectedOptions);
  });
  return numSelected;
};

export const getAttribute = (
  item: any,
  attributeIdentifier: string
): IAttribute =>
  item.attributes.find(
    (attribute: IAttribute) => attributeIdentifier === attribute.identifier
  );

export const getAttributeValue = <T extends string | number | null>(
  item: any,
  attributeIdentifier: string,
  defaultValue?: T,
  returnTranslated = false
) => {
  let value;

  if (defaultValue !== undefined) {
    value = defaultValue;
  }

  if (item) {
    const attrib = getAttribute(item, attributeIdentifier);
    if (attrib?.values?.length) {
      // @ts-ignore
      value = first(attrib.values)[
        returnTranslated ? 'translated_value' : 'value'
      ];
    }
  }

  return value;
};

export const getAllAttributeValues = (
  item: any,
  attributeIdentifier: string
) => {
  if (!item) {
    return [];
  }
  const attribute = getAttribute(item, attributeIdentifier);
  if (attribute?.values?.length) {
    return attribute.values.map((attributeValue) => attributeValue.value);
  }

  return [];
};
